import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useContatosEmergencia } from '@/hooks/useContatosEmergencia';
import { EmergencyContactsModal } from './EmergencyContactsModal';
import { PhoneIcon } from './PhoneIcon';

/**
 * Botão do Header que abre o modal de contatos de emergência — GUPM-158.
 * Container fino: busca os contatos via `useContatosEmergencia` (datasource →
 * RLS) e passa ao modal puro. Leitura apenas. Injeta a navegação do atalho
 * "Ir para Contatos" (Outros → Contatos) — GUPM-199.
 */
export function EmergencyContactsButton() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { data: contatos = [], isLoading, isError } = useContatosEmergencia();

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title="Contatos de emergência"
        aria-label="Contatos de emergência"
        className="inline-flex items-center justify-center w-9 h-[34px] rounded-[9px] bg-red-500/[.12] border border-red-500/50 text-red-300 hover:bg-red-500/20 hover:text-white transition-colors"
      >
        <PhoneIcon size={17} />
      </button>
      <EmergencyContactsModal
        isOpen={open}
        contatos={contatos}
        isLoading={isLoading}
        isError={isError}
        onClose={() => setOpen(false)}
        onIrParaContatos={() => {
          setOpen(false);
          navigate('/outros');
        }}
      />
    </>
  );
}
